import { Award, Clock, Camera, Shield, Sparkles } from "lucide-react";

const benefits = [
  {
    icon: Award,
    title: "Unmatched Quality",
    description: "Magazine-worthy images and cinematic video that elevate every listing. We don't settle for good—we deliver exceptional.",
  },
  {
    icon: Clock,
    title: "Fast Turnaround",
    description: "Most deliverables in 24-48 hours. We understand real estate moves fast, and we keep pace.",
  },
  {
    icon: Camera,
    title: "Professional Equipment",
    description: "State-of-the-art cameras, drones, and editing software to ensure your properties look their absolute best.",
  },
  {
    icon: Shield,
    title: "Reliable Consistency",
    description: "Every shoot meets the same high standards. Agents trust us because they know exactly what they're getting.",
  },
  {
    icon: Sparkles,
    title: "Industry Experience",
    description: "Years of real estate media experience means we understand what sells and how to showcase it effectively.",
  },
];

const WhyLuminateSection = () => {
  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <p className="text-primary font-medium tracking-[0.2em] uppercase text-sm mb-4">
              Why Choose Us
            </p>
            <h2 className="font-serif text-3xl md:text-5xl font-semibold text-foreground mb-6">
              Why Agents Choose <span className="text-gradient-gold">Luminate Media</span>
            </h2>
            <p className="text-muted-foreground text-lg mb-8">
              We don't just take photos—we create visual stories that sell properties. 
              Our commitment to quality, speed, and reliability makes us the preferred 
              partner for top-performing agents.
            </p>
          </div>

          <div className="space-y-6">
            {benefits.map((benefit, index) => (
              <div 
                key={benefit.title}
                className="flex gap-4 p-4 rounded-lg bg-card border border-border hover:border-primary/30 transition-colors"
              >
                <div className="flex-shrink-0 p-3 rounded-full bg-primary/10 text-primary h-fit">
                  <benefit.icon size={24} />
                </div>
                <div>
                  <h3 className="font-serif text-lg font-semibold text-foreground mb-1">
                    {benefit.title}
                  </h3>
                  <p className="text-muted-foreground text-sm">
                    {benefit.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyLuminateSection;
